import React, { ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { Header } from './components/Header';
import Drawer from './Drawer';

interface IDrawer {
  open: boolean;
  title?: string;
  extra?: ReactNode;
  loading?: boolean;
  prefix?: ReactNode;
  noHeader?: boolean;
  className?: string;
  titleClose?: string;
  children?: ReactNode;
  headerClass?: string;
  size?: 'default' | 'mini';
  onCompleteClose: () => void;
}

// Estilos com Styled Components

const DrawerContent = styled.div<{ className?: string }>`
  padding: 0 2rem;
  overflow-y: auto;
  max-height: calc(100vh - 90px);
  height: 100%;
`;

const StyledDrawer = styled(Drawer)`
  /* Estilos adicionais para o Drawer */
`;

export const DrawerComponent = ({
  open,
  size,
  extra,
  prefix,
  children,
  noHeader,
  className,
  titleClose,
  headerClass,
  onCompleteClose,
}: IDrawer) => {
  const currentSize = size === 'default' ? 600 : 474;

  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open]);

  return (
    <StyledDrawer
      open={open}
      position="right"
      size={currentSize}
      data-testid="drawer"
      className="drawer wrapper"
      onCloseOutsideClick={false}
      onCompleteClose={onCompleteClose}
    >
      {!noHeader && (
        <Header
          extra={extra}
          prefix={prefix}
          text={titleClose}
          className={headerClass}
          onClose={onCompleteClose}
        />
      )}

      <DrawerContent data-testid="drawer-content" className={className}>
        {children}
      </DrawerContent>
    </StyledDrawer>
  );
};
